import requestService from "../requestService";
import store from '@/store';

export default {
    async createService(form) {
        const response = await requestService.post(`/admin/services/create`, form, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async createServicePoint(form) {
        const response = await requestService.post(`/admin/service_text_points/create`, form, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async updateService(uuid, form) {
        const response = await requestService.post(`/admin/services/${uuid}/update`, form, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async updateServicePoint(uuid, form) {
        const response = await requestService.post(`/admin/service_text_points/${uuid}/update`, form, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async getServices() {
        const response = await requestService.get(`/services`)
        return response?.data
    },
    async getServicePoints() {
        const response = await requestService.get(`/service_text_points`)
        return response?.data
    },
    async getService(id) {
        const response = await requestService.get(`/admin/services/${id}`, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async getServicePoint(id) {
        const response = await requestService.get(`/admin/service_text_points/${id}`, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async deleteService(id) {
        const response = await requestService.delete(`/admin/services/${id}/delete`, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
    async deleteServicePoint(id) {
        const response = await requestService.delete(`/admin/service_text_points/${id}/delete`, {
            headers: { Authorization: `Bearer ${store.getters.loggedUserVivamus.token}` }
        })
        return response?.data
    },
}